import { Locale } from './lib/types/types';

export const DEFAULT_LOCALE: Locale = 'en-US';

export const ACCEPTED_DOC_MIME_TYPES: string[] = [
    'image/png',
    'image/gif',
    'image/jpg',
    'image/jpeg',
    'image/bmp',
    'application/pdf',
];

export const MAX_DOC_UPLOAD_DOCS_ALLOWED: number = 3;
export const UPLOAD_FILE_PREFIX: string = 'file';

export const QUERY_STRING_STEP_OVERRIDE: string = 'mockStep';
export const QUERY_STRING_SUBSEGMENT_OVERRIDE: string = 'mockSubSegment';
export const QUERY_STRING_ERRORID_OVERRIDE: string = 'mockErrorId';

export const DEFAULT_MINIMUM_ORG_SEARCH_VALUE_LENGTH: number = 1;

export const requestOrganizationConstants = {
    MAX_RESULT_SIZE: 25,
    ORG_TYPES: 'UNIVERSITY,HIGH_SCHOOL,K12',
    DEFAULT_ORG_TYPES: 'UNIVERSITY',
    URL_REGEX: /(https?:\/\/(www\.)?)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/,
    SCHOOL_HOUSE_URL: 'https://s3.amazonaws.com/com.sheerid.resources/common/images/requestOrganization/school.svg',
    SHEERID_LOGO_URL: 'https://s3.amazonaws.com/com.sheerid.resources/common/images/requestOrganization/logo.svg',
    FEEDBACK_FORM_URL: 'https://verify.sheerid.com/verification-support/feedback.html?token=',
};
